export const SET_MESSAGE = "messages.SET_MESSAGE";
export const CLEAR_MESSAGE = "messages.CLEAR_MESSAGE";
